import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

const Bar = styled.span`
  border-radius: 5px;
  border: 1px solid #eaeaea;
  color: #aba8a8;
  font-size: 14px;
  font-weight: normal;
  height: 100%;
  min-height: 32px;
  padding: 4px 8px;
  width: 100%;
`;

function CurrentPathBar() {
  const assetsManager = store.creative?.assets;
  const displayPath = assetsManager ? `/${assetsManager.currentFolder}` : '';
  return <Bar>{displayPath}</Bar>;
}

export default observer(CurrentPathBar);
